import { render } from "./SeleccionUbicacionModal.vue?vue&type=template&id=8db06ec2&scoped=true"
import script from "./SeleccionUbicacionModal.vue?vue&type=script&lang=js"
export * from "./SeleccionUbicacionModal.vue?vue&type=script&lang=js"

import "./SeleccionUbicacionModal.vue?vue&type=style&index=0&id=8db06ec2&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db06ec2"]])

export default __exports__